import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loading from './components/Loading/Loading';
import Error from './components/Error/Error';
import { fetchNotes } from './notesSlice';
import NotesList from './components/NotesList/NotesList';
import Edit from './components/Edit/Edit';
import SpriteEl from './components/SpriteEl/SpriteEl';

const Notes = () => {
	const dispatch = useDispatch();

	const {
		isLoading,
		error,
		isEditing
	} = useSelector(state => state.notes);

	useEffect(() => {
		dispatch(fetchNotes());
	}, [dispatch]);

	return (
		<>
			{isLoading
				? <Loading />
				: error
					? <Error />
					: isEditing
						? <Edit />
						: <NotesList />}
		</>
	);
}

export default Notes;